var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklistActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.19C0 17.83 2.17 20 5.81 20H14.19C17.83 20 20 17.83 20 14.19V5.81C20 2.17 17.83 0 14.19 0Z",
    fill: "#26875C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3105 6.86719C16.3105 7.27719 15.9805 7.61719 15.5605 7.61719H10.3105C9.90055 7.61719 9.56055 7.27719 9.56055 6.86719C9.56055 6.45719 9.90055 6.11719 10.3105 6.11719H15.5605C15.9805 6.11719 16.3105 6.45719 16.3105 6.86719Z",
    fill: "#1E1E2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97055 5.9025L5.72055 8.1525C5.57055 8.3025 5.38055 8.3725 5.19055 8.3725C5.00055 8.3725 4.80055 8.3025 4.66055 8.1525L3.91055 7.4025C3.61055 7.1125 3.61055 6.6325 3.91055 6.3425C4.20055 6.0525 4.67055 6.0525 4.97055 6.3425L5.19055 6.5625L6.91055 4.8425C7.20055 4.5525 7.67055 4.5525 7.97055 4.8425C8.26055 5.1325 8.26055 5.6125 7.97055 5.9025Z",
    fill: "#1E1E2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3105 13.8672C16.3105 14.2772 15.9805 14.6172 15.5605 14.6172H10.3105C9.90055 14.6172 9.56055 14.2772 9.56055 13.8672C9.56055 13.4572 9.90055 13.1172 10.3105 13.1172H15.5605C15.9805 13.1172 16.3105 13.4572 16.3105 13.8672Z",
    fill: "#1E1E2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97055 12.9025L5.72055 15.1525C5.57055 15.3025 5.38055 15.3725 5.19055 15.3725C5.00055 15.3725 4.80055 15.3025 4.66055 15.1525L3.91055 14.4025C3.61055 14.1125 3.61055 13.6325 3.91055 13.3425C4.20055 13.0525 4.67055 13.0525 4.97055 13.3425L5.19055 13.5625L6.91055 11.8425C7.20055 11.5525 7.67055 11.5525 7.97055 11.8425C8.26055 12.1325 8.26055 12.6125 7.97055 12.9025Z",
    fill: "#1E1E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistActive);
export default __webpack_public_path__ + "static/media/ChecklistActive.80ce4185ed49708bd5f7a962307c407f.svg";
export { ForwardRef as ReactComponent };